"use client";

import { Stub } from "@/composites/_internal";

/**
 * STUB — replaced in a subsequent ticket. See `docs/PDP_ARCHITECTURE.md`
 *
 * Intent: Hot-spot anatomy diagram for durables. STORE-033a.
 */
export function AnatomyDiagram() {
	return (
		<Stub
			name="product/AnatomyDiagram"
			intent="Hot-spot anatomy diagram for durables. STORE-033a."
		/>
	);
}
